(function($) {

	'use strict';

	var init = function() {
        toggleMainNav();
        shrinkOnScroll();
        openSearchPopup();
        toggleInnerNav();
	};
    
    var toggleMainNav = function(){
        
        $('#toggleNav').click(function(){
            
            $(this).toggleClass('active');
            $('#mainNavContainer, #targetNavContainer').toggleClass('active');
            
        });
        
    };
    
    var shrinkOnScroll = function(){
        
        $(window).scroll(function(){
            
            if($(window).scrollTop() > 150){
                $('.mainHeader').addClass('shrink');
            }else{
                $('.mainHeader').removeClass('shrink');
            }
            
        });
        
    };
    
    var openSearchPopup = function(){
        
        $('.searchToggle').click(function(){
            
            $('#searchPopup').toggleClass('open');
            
        });
        
    };
    
    var toggleInnerNav = function(){
        
        if($(window).width() > 1220){
            $('.innerNav').addClass('active');
        }
        
        $('#innerNavToggle').click(function(){
            
            $('.innerNav').toggleClass('active');
            
        });

        $('.innerNav .onepage__link .arrow').click(function(e){

            e.preventDefault();

            $(this).toggleClass('active');
            $(this).closest('.onepage').children('.submenuaside').toggleClass('active');

        });

        $(".innerNav .innerNav__link").mCustomScrollbar({
            theme:"minimal",
            scrollInertia:500,
        });
        
    };

	$(document).ready(function() {
		init();
	});

})(jQuery);
